import React, { ReactNode } from 'react';
import GoogleCheckboxRefinement from './GoogleCheckboxRefinement';
import GoogleRangeSliderRefinement from './GoogleRangeSliderRefinement';
import GoogleToggleRefinement from './GoogleToggleRefinement';

export const renderGoogleFacet = (
  facet: string,
  type: string,
  index: number,
  setDisableScroll: (v: boolean) => void,
  onDropdownToggle: (isOpen: boolean) => void,
  isSearchPage?: boolean
): ReactNode => {
  if (type === 'toggleRefinement') {
    return <GoogleToggleRefinement key={index} facet={facet} isSearchPage={isSearchPage} />;
  }
  if (type === 'rangeInput' || facet === 'Price') {
    return (
      <GoogleRangeSliderRefinement
        key={index}
        facet={facet}
        setDisableScroll={setDisableScroll}
        onDropdownToggle={onDropdownToggle}
        isSearchPage={isSearchPage}
      />
    );
  }
  return (
    <GoogleCheckboxRefinement
      key={index}
      facet={facet}
      setDisableScroll={setDisableScroll}
      onDropdownToggle={onDropdownToggle}
    />
  );
};
